import React, { useState, useEffect } from "react";
import Text from "antd/lib/typography/Text";
import { Col, Row, Table } from "antd";

import "./index.css";
import Sidebar from "../../../../components/Sidebar";
import { opsApiCall } from "../../../../helpers/rapsapOpsAuth";

export default function StaffDeliverySidebar({
  visible = false,
  data = {},
  onClose,
}) {
  const [loading, setLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    if (visible && data.staff_id) {
      getStaffPaymentDetails(1, pageSize);
    }
  }, [visible, data.staff_id]);

  const getStaffPaymentDetails = async (page = 1, size = 10) => {
    setLoading(true);
    const payload = {
      staff_id: data.staff_id,
      page: page - 1, // API uses 0-based indexing
      size: size,
    };
    const res = await opsApiCall("/rapid/getStaffPaymentDetails", payload);
    if (Array.isArray(res?.data)) {
      setPaymentDetails(res.data);
      setTotal(res.meta?.total || 0);
    }
    setLoading(false);
  };

  const handleTableChange = (pagination) => {
    const newPage = pagination.current;
    const newPageSize = pagination.pageSize;
    setCurrentPage(newPage);
    setPageSize(newPageSize);
    getStaffPaymentDetails(newPage, newPageSize);
  };

  const columns = [
    {
      title: "Payment ID",
      dataIndex: "payment_id",
      key: "payment_id",
      width: 100,
    },
    {
      title: "Order ID",
      dataIndex: "order_id",
      key: "order_id",
      width: 100,
    },
    {
      title: "Package ID",
      dataIndex: "package_id",
      key: "package_id",
      width: 110,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      width: 100,
      render: (text) => (
        <div style={{ textAlign: "right" }}>₹ {text ? text : 0}</div>
      ),
    },
    {
      title: "Payment Type",
      dataIndex: "payment_type",
      key: "payment_type",
      width: 120,
      render: (text) => (
        <div style={{ textTransform: "capitalize" }}>{text || "-"}</div>
      ),
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      key: "payment_date",
      width: 150,
    },
    {
      title: "Customer Name",
      dataIndex: "customer_details",
      key: "customer_name",
      width: 150,
      render: (customer) => customer?.name || "-",
    },
    {
      title: "Customer Phone",
      dataIndex: "customer_details",
      key: "customer_phone",
      width: 130,
      render: (customer) => customer?.phone || "-",
    },
    {
      title: "Address",
      dataIndex: "customer_details",
      key: "customer_address",
      width: 200,
      render: (customer) => {
        if (!customer) return "-";
        const address = [
          customer.address1,
          customer.address2,
          customer.city,
          customer.state,
          customer.pincode,
        ]
          .filter(Boolean)
          .join(", ");
        return address || "-";
      },
    },
  ];

  return (
    <>
      <Sidebar
        key="staff-delivery-sidebar"
        title="Staff Delivery Details"
        visible={visible}
        onClose={onClose}
        width={1200}
      >
        <Row>
          <Col className="lblc" xs={24} md={8}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Staff ID
            </Text>
            <br />
            <Text>{data.staff_id}</Text>
          </Col>
          <Col className="lblc" xs={24} md={8}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Staff Name
            </Text>
            <br />
            <Text>{data.staff_name}</Text>
          </Col>
          <Col className="lblc" xs={24} md={8}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Username
            </Text>
            <br />
            <Text>{data.username}</Text>
          </Col>
          <Col className="lblc" xs={24} md={8}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Mobile
            </Text>
            <br />
            <Text>{data.staff_mobile || "-"}</Text>
          </Col>
          <Col className="lblc" xs={24} md={8}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Total Orders Delivered
            </Text>
            <br />
            <Text>{data.total_orders_delivered || 0}</Text>
          </Col>
          <Col className="lblc" xs={24} md={8}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Total COD Orders
            </Text>
            <br />
            <Text>{data.total_cod_orders || 0}</Text>
          </Col>
          <Col className="lblc" xs={24} md={8}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Total Prepaid Orders
            </Text>
            <br />
            <Text>{data.total_prepaid_orders || 0}</Text>
          </Col>
          <Col className="lblc" xs={24} md={8}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Total Amount Collected
            </Text>
            <br />
            <Text>₹ {data.total_amount_collected || 0}</Text>
          </Col>
          <Col className="lblc" xs={24} md={8}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Amount Collected Today
            </Text>
            <br />
            <Text>₹ {data.amount_collected_today || 0}</Text>
          </Col>
          <Col className="lblc" xs={24} md={8}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Joined Date
            </Text>
            <br />
            <Text>{data.joined_date || "-"}</Text>
          </Col>
          <Col xs={24} style={{ marginTop: 24 }}>
            <Text strong style={{ fontSize: 16 }}>
              Payment Details
            </Text>
            <Table
              columns={columns}
              dataSource={paymentDetails}
              loading={loading}
              rowKey="payment_id"
              scroll={{ x: 1400 }}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: total,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} payments`,
                pageSizeOptions: ["10", "20", "50", "100"],
              }}
              onChange={handleTableChange}
              style={{ marginTop: 15 }}
            />
          </Col>
        </Row>
      </Sidebar>
    </>
  );
}
